import { Link } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { getLoginByCorporateId } from 'modules/auth/utils/getLoginByCorporateId';

type LoginHeaderProps = {
  blockedMode?: boolean;
  customStyle: {
    logo: string;
    accessTitle: string;
    accessText: string;
  };
};

const LoginHeader: FC<LoginHeaderProps> = ({ blockedMode, customStyle }) => {
  const { t } = useTranslate();

  const { logo, accessText, accessTitle } =
    customStyle || getLoginByCorporateId();

  return (
    <>
      <div className="brand-logo pb-5">
        <Link to="/" className="logo-link">
          <img
            className={`logo-light logo-img logo-img-lg ${
              blockedMode ? 'h-50px mh-50px' : ''
            }`}
            src={logo}
            srcSet={logo}
            alt="logo"
          />
          <img
            className={`logo-dark logo-img logo-img-lg ${
              blockedMode ? 'h-50px mh-50px' : ''
            }`}
            src={logo}
            srcSet={logo}
            alt="logo-dark"
          />
        </Link>
      </div>

      {!blockedMode && (
        <>
          <div className="nk-block-head">
            <div className="nk-block-head-content">
              <h5 className="nk-block-title">{t(accessTitle)}</h5>
              <div className="nk-block-des">
                {accessText && <p>{t(accessText)}.</p>}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LoginHeader;
